import React from 'react'
import store, { history } from '../store'
import { getCountryOptions, getUSADefault } from '../components/Wizard2/selectOptions'
import orderBy from 'lodash/orderBy'
import deepEqual from 'deep-equal'
import { clearLocalUser } from '../Auth/AuthActions'
import { setErrorToast, setOffline } from '../actions'
import { resolveFieldConditions } from '@tecuity/wizard-utilities'
import { BUSINESS_RULES } from 'components/Wizard2/businessRules'
import * as WIZARD_CLASSES from 'components/Wizard2/WizardClasses'
import objectToHash from 'object-hash'
import defaultTheme from '!!dart-sass-variable-loader!../common/css/_default.scss'
import { HAS_KEYSTONE_LOGIN } from '../../state-configs/PA.config'
import { SUBROUTES } from '../App'
import Cookies from 'js-cookie'
import * as api from 'requests'
import { PDFDocument } from 'pdf-lib'
import { openSpecificImage } from '../components/ImageViewer/ImageViewerActions'
import { checkDLNValid } from '../components/BOSearch/BOSearchActions'
import { useDispatch } from 'react-redux'

const themeOverride = require(
  '!!dart-sass-variable-loader!../common/css/themes/' + process.env.STATE_ABBR + '/_override.scss',
)

export const theme = {
  ...defaultTheme,
  ...themeOverride,
}

export const parseUrlQuery = (input, props = {}) => {
  try {
    let search = input.split('?')
    search = search.slice(1).join('?')
    let partsArray = search ? search.split('&') : []
    let output = {}
    partsArray.forEach((part) => {
      let pair = part.split('=')
      output[pair[0]] = decodeURIComponent(pair.slice(1).join('='))
    })
    return output
  } catch (e) {
    console.error(e)
    return props.failType !== undefined ? props.failType : {}
  }
}

export const getSanitizedLocalStorageValue = (key, parse) => {
  let value = localStorage.getItem(key)
  return value !== '' && value !== 'undefined' && value !== 'null' && value !== undefined
    ? parse
      ? JSON.parse(value)
      : value
    : null
}

export const notNullOrUndefined = (value) => value !== null && value !== undefined

export const lowercaseFirstLetter = (string = '') =>
  string.charAt(0).toLowerCase() + string.slice(1)

export const getSelectedOptionFromField = (field, valueIfNotFound) => {
  const selected = ((field || {}).options || []).find((option) => field.value == option.value)
  return selected ? selected : valueIfNotFound
}

export const getFieldsByType = (type, fields, returnType = 'array') => {
  let fieldArray = []
  let fieldObject = {}
  const push = (field) => {
    if (returnType === 'array') fieldArray.push(field)
    else fieldObject[field.fieldId] = field
  }
  Object.keys(fields).forEach((fieldId) => {
    if (Array.isArray(type)) {
      if (type.includes(fields[fieldId].type)) {
        push(fields[fieldId])
      }
    } else {
      if (fields[fieldId].type === type) {
        push(fields[fieldId])
      }
    }
  })
  switch (returnType) {
    case 'array':
      return fieldArray.length > 0 ? fieldArray : null
    case 'object':
      return Object.keys(fieldObject) > 0 ? fieldObject : null
    default:
      console.warn(
        `"${returnType}" is not a valid return type. Valid return types are "array" and "object"`,
      )
      return null
  }
}

export const getFreshValueFromStoreByFieldId = (fieldId, fromEntityNameSearch = false) => {
  return fromEntityNameSearch
    ? store.getState().wizard.wizard.fields[fieldId].value.uploadField
    : store.getState().wizard.wizard.fields[fieldId].value
}

export const objectToArray = (obj = {}, options = {}) => {
  if (options.persistKey === true) {
    return Object.keys(obj).map((key) => ({ [key]: obj[key] }))
  } else {
    return Object.keys(obj).map((key) => obj[key])
  }
}

export const getCurrentWizardMetaData = () => store.getState().wizard.wizard.meta

export const getCurrentWizardAmendmentNum = () => store.getState().wizard.wizard.amendmentNum

export const FormattedAddress = ({ value, showCounty, showCountry, className = '' }) => {
  if (value) {
    let country = getCountryOptions().find((option) => option.value === value.COUNTRY)
    return (
      <span className={className}>
        {value.ADDR1} <br />
        {value.ADDR2}
        {value.ADDR2 !== '' && value.ADDR2 ? <br /> : null}
        {value.ADDR3}
        {value.ADDR3 !== '' && value.ADDR3 ? <br /> : null}
        {isCountryUSA(value.COUNTRY) && value.ADDR1 !== ''
          ? (value.CITY || '').trim() + ', ' + value.STATE + ' ' + value.POSTAL_CODE
          : null}
        {value.COUNTRY === '' ? <br /> : null}
        {value.COUNTY !== '' && value.COUNTY && value.COUNTRY !== '' && value.COUNTRY ? (
          <br />
        ) : null}
        {value.COUNTY !== '' && value.COUNTY && showCounty
          ? value.COUNTY +
            (showCountry && value.COUNTRY !== '' && value.COUNTRY && !isCountryUSA(value.COUNTRY)
              ? ', '
              : '')
          : null}
        {showCountry && value.COUNTRY !== '' && value.COUNTRY && !isCountryUSA(value.COUNTRY)
          ? country
            ? country.label
            : null
          : null}
      </span>
    )
  } else {
    return null
  }
}

export const FormattedAddressNew = ({ value, showCounty, showCountry, className = '' }) => {
  if (value) {
    let country = getCountryOptions().find((option) => option.value === value.Country)
    return (
      <span className={className}>
        {value.AddressLine1} <br />
        {value.AddressLine2}
        {value.AddressLine2 !== '' && value.AddressLine2 ? <br /> : null}
        {value.AddressLine3}
        {value.AddressLine3 !== '' && value.AddressLine3 ? <br /> : null}
        {value.Country.toLowerCase() === 'united states' && value.AddressLine1 !== ''
          ? (value.City || '').trim() + ', ' + value.StateOrProvince + ' ' + value.PostalCode
          : null}
        {value.Country === '' ? <br /> : null}
        {value.County !== '' && value.County && value.Country !== '' && value.Country ? (
          <br />
        ) : null}
        {value.County !== '' && value.County && showCounty
          ? value.County +
            (showCountry &&
            value.Country !== '' &&
            value.Country &&
            value.Country !== 'United States'
              ? ', '
              : '')
          : null}
        {showCountry && value.Country !== '' && value.Country && value.Country !== 'United States'
          ? country
            ? country.label
            : null
          : null}
      </span>
    )
  } else {
    return null
  }
}

export const getFieldsWithChangedValues = () => {
  const {
    diff: { originalByFieldId },
    wizard: { fields },
  } = store.getState().wizard
  return Object.keys(fields).reduce((filtered, fieldId) => {
    if (
      fields[fieldId].parent.type.toUpperCase() !== 'REPEATER' &&
      (fields[fieldId].type.toUpperCase() !== 'FILE' ||
        (fields[fieldId].value.length !== 0 && !originalByFieldId[fieldId])) &&
      !deepEqual(fields[fieldId].value, originalByFieldId[fieldId])
    ) {
      return [...filtered, fields[fieldId]]
    } else {
      return filtered
    }
  }, [])
}

export const truncateText = (string, maxLength, ellipsis = true) => {
  if (string.length <= maxLength) {
    return string
  } else {
    return string.slice(0, maxLength) + (ellipsis ? '...' : '')
  }
}

export const getOrderedResultsByCategory = (category, items, templates) => {
  if (items[category]) {
    return {
      template: templates[category],
      rows: orderBy(
        Object.keys(items[category]).map((rowId) => items[category][rowId]),
        ['SORT_INDEX'],
        ['asc'],
      ),
    }
  } else {
    return { template: [], rows: [] }
  }
}

export const noop = () => {}

export const readFileAsText = (e) =>
  new Promise((resolve, reject) => {
    var reader = new FileReader()
    reader.onload = () => {
      resolve(JSON.parse(reader.result))
    }
    reader.readAsText(e.target.files[0])
  })

export const getNumBusinessRules = (rules, allRules = BUSINESS_RULES) =>
  rules.reduce((count, rule) => {
    if (!allRules[rule.fn].excludeFromCount) {
      return count + 1
    } else {
      return count
    }
  }, 0)

export const getSourceTypeId = (category) => {
  const route = SUBROUTES.find((x) => x.parameter == category)
  return route ? route.SourceTypeId : 0
}

const randomWords = {
  colors: ['Red', 'Blue', 'Green', 'Yellow', 'Orange', 'Purple', 'Pink', 'Silver'],
  animals: [
    'Giraffe',
    'Elephant',
    'Cat',
    'Puppy',
    'Unicorn',
    'Panther',
    'Mammoth',
    'Snake',
    'Dragon',
    'Chicken',
    'Lasagna',
    'Meatloaf',
    'Cupcake',
    'Cookie',
  ],
  occupations: [
    'Bakers',
    'Chefs',
    'Smithies',
    'Movers',
    'Keepers',
    'Designers',
    'Dancers',
    'Actors',
    'Preachers',
    'Managers',
    'Magicians',
    'Horticulturalists',
  ],
}

const getRandomWordByType = (type) =>
  randomWords[type][Math.floor(Math.random() * randomWords[type].length)]

const getUniqueJSONValuesByFieldName = (fieldName, json) => {
  if (json.FIELD_VALUES[fieldName] && typeof json.FIELD_VALUES[fieldName] === 'string') {
    const uniqueName = `${getRandomWordByType('colors')} ${getRandomWordByType(
      'animals',
    )} ${getRandomWordByType('occupations')}`
    if (json.FIELD_VALUES[fieldName].includes('[ID]')) {
      const val1 = json.FIELD_VALUES[fieldName].replace(/\[ID\]/g, uniqueName)
      json.FIELD_VALUES[fieldName] = val1
    }
  }
  return json
}

export const getUniqueJSONvalues = (json) => {
  if (
    json.FIELD_VALUES.ENTITY_NAME_INFO &&
    typeof json.FIELD_VALUES.ENTITY_NAME_INFO === 'object'
  ) {
    const uniqueName = `${getRandomWordByType('colors')} ${getRandomWordByType(
      'animals',
    )} ${getRandomWordByType('occupations')}`
    if (json.FIELD_VALUES.ENTITY_NAME_INFO.val1.includes('[ID]')) {
      const val1 = json.FIELD_VALUES.ENTITY_NAME_INFO.val1.replace(/\[ID\]/g, uniqueName)
      json.FIELD_VALUES.ENTITY_NAME_INFO = {
        ...json.FIELD_VALUES.ENTITY_NAME_INFO,
        val1,
        val2: val1,
      }
    }
  }
  json = getUniqueJSONValuesByFieldName('ENTITY_NAME', json)
  json = getUniqueJSONValuesByFieldName('TRADEMARK_NAME', json)
  return json
}

export const handleForbiddenResponse = (isGateway, url) => {
  //Redirects to auth route if not already on an auth route.
  //Returns boolean of whether or not it redirected.
  store.dispatch({ type: 'SET_LOGIN_REDIRECTING', loginRedirecting: true })
  const pathname = history.location.pathname
  if (isGateway) {
    const errorMessage =
      store.getState().app.appSettings['WAF_FORBIDDEN_ERROR_MESSAGE'] ||
      'ERROR ID: 125f2d99-2797-427c-bfb6-c71fc7542ad9 \n Request:' + url
    store.dispatch(setErrorToast(errorMessage))
    return true
  } else if (pathname !== '/admin' && pathname !== '/auth') {
//////////////////////
/////////////////////////////////////////////
////////////////////////////////////////////////////

///////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////
///////

/////////////////////
/////////////////
///////////////////////
///////////////////////////////////////////////////////////////
//////////
/////////////////////
///////////////////////////////
//////////
///////
////////////
//////////////////////////////////////
/////
/////////////
    history.replace(getAuthRedirectUrl(history.location))
//////////////
    clearLocalUser()
    return true
  } else {
    return false
  }
}

export const handleOfflineResponse = () => {
  store.dispatch(setOffline(true))
  clearLocalUser()
}

export const getAuthRedirectUrl = (location) => {
  let lastUsersGroup = getSanitizedLocalStorageValue('LAST_USERS_GROUP')
  lastUsersGroup = lastUsersGroup ? JSON.parse(lastUsersGroup) : lastUsersGroup
  return `/${
    HAS_KEYSTONE_LOGIN
      ? 'auth'
      : lastUsersGroup === 'ADMIN' || lastUsersGroup === 'ADMIN_WEB'
        ? 'admin'
        : 'auth'
  }?from=${encodeURI(location.pathname)}${location.search ? '&search=' : ''}${location.search}`
}

export const calculateReceiptItemsTotal = (receiptItems = []) =>
  Array.isArray(receiptItems) && receiptItems.length > 0
    ? receiptItems.reduce((accumulator, currentVal) => accumulator + currentVal.LINE_TOTAL, 0)
    : 0

export const calculateReceiptItemContainersTotal = (receiptItemContainers = []) =>
  Array.isArray(receiptItemContainers) &&
  receiptItemContainers.reduce(
    (t, container) =>
      (container.RECEIPT_ITEM_WEB_LIST.length > 0
        ? container.RECEIPT_ITEM_WEB_LIST.reduce(
            (accumulator, currentVal) => accumulator + currentVal.LINE_TOTAL,
            0,
          )
        : 0) + t,
    0,
  )

export const getControlIsRenderable = (address, fields) => {
  if (!address || !fields) return false
  if (address.parent.type === 'OPTION') {
    const parent = fields[address.parent.id]
    if (!parent) return false
    const selected = getSelectedOptionFromField(parent, null)
    if (!selected) return false
    if (!selected.fields.includes(address.fieldId)) return false
  }
  if (address.parent.type === 'CHECKBOX') {
    const parent = fields[address.parent.id]
    if (!parent) return false
    const selected = parent.value === true ? parent.checkedFields : parent.uncheckedFields
    if (!selected) return false

    if (!selected.includes(address.fieldId)) return false
  }
  if (!resolveFieldConditions(address.conditions, fields, address.conditionsOperator)) return false
  return true
}

export const convertRepeaterRowsToColumnsObject = (template, rows) =>
  template.reduce((obj, fieldId) => {
    return {
      ...obj,
      [fieldId]: rows.map((row) => row[fieldId]),
    }
  }, {})

export const testRepeaterConstraints = (constraints, rows, fields) =>
  constraints.map((constraint) => {
    const hashTable = rows.map((row) =>
      constraint.fields.reduce((hash, fieldId) => {
        const fieldObj = fields[fieldId] || {}
        const field = WIZARD_CLASSES[fieldObj.fieldClass]
        if (field) {
          const instance = { ...fieldObj, value: row[fieldId] }
          const compValue = new field(instance).getCompareValue(instance)
          if (typeof compValue === 'object') {
            return hash + objectToHash(compValue)
          } else {
            return hash + compValue
          }
        } else {
          return hash
        }
      }, ''),
    )
    hashTable.sort()
    return !getArrayHasDuplicates(hashTable)
  })

const getArrayHasDuplicates = (arr) => {
  for (let i = 0; i < arr.length - 1; i++) {
    if (arr[i] === arr[i + 1]) return true
  }
  return false
}

export const getFieldByKey = (keyValue, key, fields = {}, returnType = 'object') => {
  if (returnType === 'array') {
    return Object.entries(fields).reduce(
      (arr, [k, v]) => (v[key] === keyValue ? [...arr, v] : arr),
      [],
    )
  } else {
    return Object.entries(fields).reduce(
      (obj, [k, v]) => (v[key] == keyValue ? { ...obj, [k]: v } : obj),
      {},
    )
  }
}

export const getHydratedFields = (row, template, fields) =>
  Object.entries(fields).reduce((obj, [fieldId, field]) => {
    if (template.includes(fieldId)) {
      return {
        ...obj,
        [fieldId]: {
          ...field,
          value: row[fieldId],
        },
      }
    }
    return { ...obj, [fieldId]: field }
  }, {})

export const formatSignaturesForServer = (signatures) => {
  return signatures.map(
    ({
      _rowId: ROW_ID,
      '~~SIGNER_EMAIL_FH42JAD8942KDW~~': EMAIL,
      '~~SIGNER_NAME_JHEK12LKHK12KJ~~': SIGNER_NAME,
      ...sig
    }) => ({
      ROW_ID,
      SIGNER_NAME: new WIZARD_CLASSES.FullName({ value: SIGNER_NAME }).getHumanReadableValue(
        { value: SIGNER_NAME },
        SIGNER_NAME,
      ),
      EMAIL,
      ...sig,
    }),
  )
}

export const getFirstFocusableScopedElement = (scope = '', postScope = '') => {
  const focusableSelectors = [
    'button',
    '[href]',
    'input',
    'select',
    'textarea',
    '[tabindex]:not([tabindex="-1"])',
  ]
    .map((x) => `${scope} ` + x + postScope)
    .join(', ')
  const focusables = document.querySelectorAll(focusableSelectors)
  return focusables[0]
}

export const getFieldsByFieldIds = (fieldIds, fields) =>
  fieldIds.reduce((obj, fieldId) => {
    obj[fieldId] = fields[fieldId]
    return obj
  }, {})

export const getRequiredAppSettingNames = (fields) =>
  fields.reduce((settingNames, field) => {
    Object.values(field.logicNodes).forEach((node) => {
      if (node.type === 'booleanAppSetting') {
        if (node.inputData.booleanAppSetting.booleanAppSetting) {
          settingNames.push(node.inputData.booleanAppSetting.booleanAppSetting)
        }
      }
      if (node.type === 'stringAppSetting') {
        if (node.inputData.stringAppSetting.stringAppSetting) {
          settingNames.push(node.inputData.stringAppSetting.stringAppSetting)
        }
      }
    })
    return settingNames
  }, [])

export const coerceType = (value, defaultValue) => {
  if (typeof value !== typeof defaultValue) {
    return defaultValue
  } else {
    return value
  }
}

export const hydrateSublinkFunctions = (rawSublink) => {
  const sublink = {
    ...rawSublink,
  }
  if (rawSublink.advancedSearchParameters) {
    sublink.advancedSearchParameters = rawSublink.advancedSearchParameters.map((rawParam) => {
      const param = {
        ...rawParam,
      }
      if (typeof rawParam.getProps === 'string') {
        // eslint-disable-next-line no-new-func
        param.getProps = new Function('values', rawParam.getProps)
      }
      if (typeof rawParam.setValue === 'string') {
        // eslint-disable-next-line no-new-func
        param.setValue = new Function('value', rawParam.setValue)
      }
      return param
    })
  }
  if (typeof rawSublink.searchRequirementsAreSatisfied === 'string') {
    // eslint-disable-next-line no-new-func
    sublink.searchRequirementsAreSatisfied = new Function(
      'search',
      'values',
      sublink.searchRequirementsAreSatisfied,
    )
  }
  return sublink
}

export const getHumanReadableValueByField = (field) => {
  return new WIZARD_CLASSES[field.fieldClass](field).getHumanReadableValue(field, field.value)
}

export const isCountryUSA = (country = '') => {
  // console.log(country, getUSADefault(), country === getUSADefault(), country === '')
  return country === getUSADefault() || country === ''
}

export const returnEmptyStringForNull = (str) => {
  if (!str) {
    return ''
  } else {
    return str
  }
}

export const getRecordSourceTypeIdFromFilingSourceTypeId = (filingSourceTypeId) => {
  switch (filingSourceTypeId) {
    case 169: // Business
      return 54
    case 157: // Registered Agent
      return 462
    case 2000: // UCC/Lein
      return 1999
    case 851: // Notary
      return 850
    case 811: // Trademark
      return 810
    case 1300: // Charity
      return 1300
    case 1400: // Contractor
      return 1400
    case 1500: // Lobbyist
      return 1500
    default:
      return null
  }
}

export const getFilingSourceTypeIdFromRecordSourceTypeId = (recordSourceTypeId) => {
  switch (recordSourceTypeId) {
    case 54: // Business
      return 169
    case 462: // Registered Agent
      return 157
    case 1999: // UCC/Lein
      return 2000
    case 850: // Notary
      return 851
    case 810: // Trademark
      return 811
    case 1300: // Charity
      return 1300
    case 1400: // Contractor
      return 1400
    case 1500: // Lobbyist
      return 1500
    default:
      return null
  }
}

export const FilingSourceTypeIds = {
  Orders: 167,
  Business: 169,
  RegisteredAgent: 462,
  Receipt: 513,
  Apostille: 720,
  Trademark: 811,
  Notary: 851,
  Facsimile: 852,
  AthleteAgent: 1001,
  ServiceOfProcess: 1100,
  Legacy: 1200,
  Charity: 1300,
  Contractor: 1400,
  Lobbyist: 1500,
  Lien: 2000,
  InfoRequest: 2001,
  Miscellaneous: 3000,
}

export { formatPascalCaseLabel } from './StringUtilities'

export const MiscJobDaysOfWeek = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
]

export const MiscJobDaysOfMonth = [
  ...Array.from({ length: 31 }, (_, i) => ({ value: i + 1, label: String(i + 1) })),
  { value: 'last', label: 'Last Day of Month' },
]

export const MiscJobMonths = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
]

export const defaultMiscJobSchedule = {
  MinuteInterval: null, // Minute Interval frequency
  TimeOfDay: null,      // "HH:mm" (24h) — Daily/Weekly/Monthly/Yearly
  DayOfWeek: null,      // 0-6 — Weekly
  DayOfMonth: null,     // 1-31 — Monthly and Yearly
  IsLastDayOfMonth: false, // Monthly "Last Day of Month" option
  Month: null,          // 1-12 — Yearly
}

export const ProcessingStatusIds = {
  PendingPaymentDocuments: 561,
  SupervisorReview : 562,
  PendingSecondaryReview: 563,
  SentToInitialReviewer: 564,
  PendingCountyReview : 6900,
  PendingImageCrop: 7000, //Currently only in use for Trademark
  PendingCountyCorrection : 6700

}

export const EntryTypeIds = {
  WebFiled: 1117,
  WebPrepared: 1118,
  PaperFiled: 1119,
}

/**
 * Merge multiple PDF byte arrays into a single PDF
 * @param {Uint8Array[] | ArrayBuffer[]} pdfByteArrays - Array of PDF byte arrays
 * @returns {Promise<Uint8Array>} - Merged PDF as a byte array
 */
export async function mergePdfByteArrays(pdfByteArrays) {
  if (!Array.isArray(pdfByteArrays) || pdfByteArrays.length === 0) {
    throw new Error('Input must be a non-empty array of PDF byte arrays.')
  }

  // Create a new PDFDocument to hold merged pages
  const mergedPdf = await PDFDocument.create()

  for (const pdfBytes of pdfByteArrays) {
    try {
      // Load each PDF
      const pdf = await PDFDocument.load(pdfBytes)

      // Copy all pages from the current PDF into the merged PDF
      const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices())
      copiedPages.forEach((page) => mergedPdf.addPage(page))
    } catch (err) {
      console.error('Error processing one of the PDFs:', err)
    }
  }

  // Save merged PDF as Uint8Array.
  return await mergedPdf.save()
}

export const useGetDLNLink = (dln, classNameOverride = null) => {
  const dispatch = useDispatch()
  if (dln) {
    return (
      <div
        className={dln.indexOf(',') === -1 ? classNameOverride || 'dlnTableLink' : ''}
        tabIndex={dln.indexOf(',') === -1 ? 0 : -1}
        onClick={() => {
          return dln.indexOf(',') === -1
            ? checkDLNValid(
                dln,
                (id) => {
                  dispatch(openSpecificImage(id, dln))
                },
                (dln) => {
                  dispatch(setErrorToast('DLN ' + dln + ' not found'))
                },
              )
            : null
        }}
      >
        {dln}
      </div>
    )
  } else {
    return ''
  }
}
